module.exports = __webpack_public_path__ + "6afb67dc93eacf380854fdf0e9918643.png";